function parseStyleAttribute(style) {
  if (!style) {
    return void 0;
  }
  const propPairs = [];
  const currProp = {
    parseMode: "name",
    name: "",
    value: ""
  };
  for (let i = 0; i < style.length; i++) {
    const currChar = style.charAt(i);
    switch (currChar) {
      case ":":
        currProp.parseMode = "value";
        break;
      case ";": {
        const name = currProp.name.trim();
        const value = currProp.value.trim();
        if (name && value) {
          propPairs.push({
            name,
            value
          });
        }
        currProp.parseMode = "name";
        currProp.name = "";
        currProp.value = "";
        break;
      }
      default:
        switch (currProp.parseMode) {
          case "name":
            currProp.name += currChar;
            break;
          case "value":
            currProp.value += currChar;
        }
    }
  }
  return propPairs.reduce((acc, prop) => {
    acc[prop.name] = prop.value;
    return acc;
  }, {});
}

export { parseStyleAttribute };
//# sourceMappingURL=util.parse-style-attribute.js.map
